import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-score-step',
  templateUrl: './score-step.component.html',
  styleUrls: ['./score-step.component.scss']
})
export class ScoreStepComponent implements OnInit {
  @Output() nextStepEvent = new EventEmitter();
  public slots = [
    {
      value: 0,
      color: '#CC0000'
    },
    {
      value: 1,
      color: '#FF0000'
    },
    {
      value: 2,
      color: '#FF5500'
    }
    , {
      value: 3,
      color: '#FF7733'
    }
    , {
      value: 4,
      color: '#FFAA00'
    }
    , {
      value: 5,
      color: '#FFBB33'
    }
    , {
      value: 6,
      color: '#33CC99'
    }
    , {
      value: 7,
      color: '#5CD6AD'
    }
    , {
      value: 8,
      color: '#3377FF'
    },
    {
      value: 9,
      color: '#0055FF'
    },
    {
      value: 10,
      color: '#003399'
    }
  ];
  @Input() score: number;
  public hoverIndex = -1;
  constructor() { }

  ngOnInit(): void {
  }

  setScore(index: number): void {
    this.score = index;
    this.hoverIndex = -1;
  }
  onHover(index: number): void {
    this.hoverIndex = index;
  }

  nextStep(): void {
    this.nextStepEvent.emit({
      nextStep: 'comment-step',
      score: this.score
    });
  }
}
